import 'core-js';
import Points from './Points';
import ParallaxComponent from './ParallaxComponent';
import Scroll from './Scroll';
import Map from './Map';
import Analytics from './Analytics';
import Cookies from './Cookies';
import 'dom-slider';
// import { tns } from "tiny-slider";
import * as basicLightbox from 'basiclightbox';

let responsiveBreakpoint = 900;

document.addEventListener("DOMContentLoaded", ()=> {

    AOS.init();

    new Cookies();

    let current = 0, slides = document.querySelectorAll('.opener__image:not(.opener__image--loader)');
    //
    // let url = slides[0].style.backgroundImage.match(/\((.*?)\)/)[1].replace(/('|")/g,'');
    // let img = new Image();
    // img.src = url;

    setTimeout(() => {
      document.querySelector('.opener__image--loader').classList.add('opener__image--hide');
      setInterval(() => {
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.opacity = 0;
        }
        current = (current != slides.length - 1) ? current + 1 : 0;
        slides[current].style.opacity = 1;
      }, 5000);
      new Points();
    }, 1500);

    new ParallaxComponent('[data-parallax]');
    new Analytics();

    let navToggle = document.querySelector('.side__toggle'),
        nav = document.querySelector('nav'),
        navOpenedClass = 'nav--opened';
    navToggle.addEventListener('click', () => {
        nav.classList.toggle(navOpenedClass);
        if (nav.classList.contains(navOpenedClass)) {
            Analytics.sendEvent('menu', 'click', 'otevreni_menu');
        }
    });

    new Scroll(navOpenedClass);

    let productArrows = document.querySelector('.products__arrows');
    window.addEventListener('mousemove', (e) => {
        rotate(e, productArrows, 10);
    });

    // --- products slider
    let productsSlider = tns({
        container: '.products-slider__wrapper',
        controls: false,
        nav: false,
        autoplay: true,
        preventScrollOnTouch: 'auto'
    });

    let productSliderNext = document.querySelector('.product-slider .slider-arrow--left');
    productSliderNext.addEventListener('click', () => {
        productsSlider.goTo('prev');
        productsSlider.pause();
        // productsSlider.play();
        Analytics.sendEvent('slider1', 'click', 'co_delame');
    });

    let productSliderPrev = document.querySelector('.product-slider .slider-arrow--right');
    productSliderPrev.addEventListener('click', () => {
        productsSlider.pause();
        // productsSlider.play();
        productsSlider.goTo('next');
        Analytics.sendEvent('slider1', 'click', 'co_delame');
    });

    // --- features slider
    let featuresSlider = tns({
        container: '.features-content',
        controls: false,
        nav: false,
        preventScrollOnTouch: 'auto',
        autoplay: true,
        touch: false,
    });

    let featuresSection = document.querySelector('section.features');

    let featuresSliderPlays = document.querySelectorAll('[data-feature-play]');
    for (let i = 0; i < featuresSliderPlays.length; i++) {
        featuresSliderPlays[i].addEventListener('click', (e) => {
           e.preventDefault();
           featuresSlider.play();
           featuresSection.classList.remove('paused');
        });
    }

    let featuresSliderPauses = document.querySelectorAll('[data-feature-pause]');
    for (let i = 0; i < featuresSliderPauses.length; i++) {
        featuresSliderPauses[i].addEventListener('click', (e) => {
            e.preventDefault();
            featuresSlider.pause();
            featuresSection.classList.add('paused');
        });
    }

    let featuresSliderDescriptions = document.querySelectorAll('.features-description__item'),
        featuresSliderActive = 'features-description__item--active',
        pointActiveClass = 'point--active',
        idx = 0;

    featuresSlider.events.on('transitionStart', () => {
        for (let i = 0; i < featuresSliderDescriptions.length; i++) {
          featuresSliderDescriptions[i].classList.remove(featuresSliderActive);
        }
    });

    featuresSlider.events.on('transitionEnd', () => {
        let index = featuresSlider.getInfo().displayIndex - 1,
            currentItem = featuresSliderDescriptions[index];
        currentItem.classList.add(featuresSliderActive);
        let points = currentItem.querySelectorAll('.point');
        if (typeof points[index] !== 'undefined') {
            points[index].classList.add(pointActiveClass);
            idx = index;
        }
    });

    let featuresSliderPrev = document.querySelector('.features-wrapper .slider-arrow--left');
    featuresSliderPrev.addEventListener('click', () => {
        featuresSlider.goTo('prev');
        featuresSlider.pause();
        featuresSection.classList.add('paused');
        // featuresSlider.play();
        Analytics.sendEvent('slider2', 'click', 'technologie');
    });

    let featuresSliderNext = document.querySelector('.features-wrapper .slider-arrow--right');
    featuresSliderNext.addEventListener('click', () => {
        featuresSlider.goTo('next');
        featuresSlider.pause();
        featuresSection.classList.add('paused');
        // featuresSlider.play();
        Analytics.sendEvent('slider2', 'click', 'technologie');
    });

    let points = [];
    for (let i = 0; i < featuresSliderDescriptions.length; i++) {
      points.push(featuresSliderDescriptions[i].querySelectorAll('.point'));
    }

    for (let i = 0; i < points.length; i++) {
      for (let j = 0; j < points[i].length; j++) {
        points[i][j].addEventListener('click', (e) => {
          e.preventDefault();
          featuresSlider.goTo(j);
          featuresSlider.pause();
          featuresSection.classList.add('paused');
        });
      }
    }

    let people = document.querySelectorAll('.person');
    if (window.innerWidth > responsiveBreakpoint) {
      window.addEventListener('mousemove', (e) => {
        for (let i = 0; i < people.length; i++) {
          let person = people[i];
          rotate(e, person, 5);
        }
      });
    }

    //--- references slider
    let referencesSlider = tns({
      container: '.references-slider__wrapper',
      controls: false,
      nav: false,
      fixedWidth: false,
      autoplay: true,
      // preventScrollOnTouch: true,
      loop: true,
      touch: false,
      responsive: {
          1140: {
            fixedWidth: 1170,
          }
      },
      preventActionWhenRunning: true
    });

    let referencesSection = document.querySelector('section.references');

    let referencesSliderPlays = document.querySelectorAll('[data-reference-play]');
    for (let i = 0; i < referencesSliderPlays.length; i++) {
        referencesSliderPlays[i].addEventListener('click', (e) => {
            e.preventDefault();
            referencesSlider.play();
            referencesSection.classList.remove('paused');
        });
    }

    let referencesSliderPauses = document.querySelectorAll('[data-reference-pause]');
    for (let i = 0; i < referencesSliderPauses.length; i++) {
        referencesSliderPauses[i].addEventListener('click', (e) => {
            e.preventDefault();
            referencesSlider.pause();
            referencesSection.classList.add('paused');
        });
    }

    referencesSlider.events.on('indexChanged', (info, event) => {
      let slideItems = info.slideItems[info.index];
      initLinkOnChange(slideItems);
    });

    referencesSlider.goTo(1);

    let referencesSliderPrev = document.querySelector('.references-slider__arrow--left'),
        referencesSliderNext = document.querySelector('.references-slider__arrow--right');

    referencesSliderNext.addEventListener('click', () => {
       referencesSlider.goTo('next');
       referencesSlider.pause();
       referencesSection.classList.add('paused');
       // referencesSlider.play();
        Analytics.sendEvent('slider3', 'click', 'reference');
    });

    referencesSliderPrev.addEventListener('click', () => {
        referencesSlider.goTo('prev');
        referencesSlider.pause();
        referencesSection.classList.add('paused');
        // referencesSlider.play();
        Analytics.sendEvent('slider3', 'click', 'reference');
    });

  let footerLink = document.querySelector('footer a');
  footerLink.addEventListener('click', (e) => {
    e.preventDefault();
    Scroll.smoothScrollTo(0, 0, 1000);
  });

  // let itemPoints =

  new Map();

  let dots = Array.from(document.querySelectorAll('#opener__dots circle'));
  dots = shuffle(dots);
  for (let i = 0; i < dots.length; i++) {
    setTimeout(() => {
      dots[i].classList.add('circle--visible');
    }, i * 25);
  }

  if (window.innerWidth <= responsiveBreakpoint) {
    let supportSliderPrev = document.querySelector('.support .slider-arrow--left'),
        supportSliderNext = document.querySelector('.support .slider-arrow--right');
    let supportSlider = tns({
      container: '.support .support__row',
      controls: false,
      nav: false,
      autoplay: true,
      loop: true,
      center: true,
      items: 1,
      autoWidth: true,
      preventScrollOnTouch: 'auto',
    });
    supportSliderPrev.addEventListener('click', () => {
      supportSlider.goTo('prev');
      supportSlider.pause();
      supportSlider.play();
    });
    supportSliderNext.addEventListener('click', () => {
      supportSlider.goTo('next');
      supportSlider.pause();
      supportSlider.play();
    });
  }

  if (window.innerWidth <= 500) {
    let instaSlider = tns({
      container: '.instagram__row',
      controls: false,
      nav: false,
      autoplay: true,
      center: false,
      items: 1,
      preventScrollOnTouch: 'auto',
    });
  }

  let contactMoreLink = document.querySelector('.contacts__more-btn'),
      contactMore = document.querySelector('.contacts__more-content');

  contactMoreLink.addEventListener('click', (e) => {
    e.preventDefault();
    contactMore.slideToggle(500).then(() => {
      if (contactMore.classList.contains('DOM-slider-hidden')) {
        contactMoreLink.innerHTML = window.contactsMore;
      } else {
        contactMoreLink.innerHTML = window.contactsLess;
      }
    });
  });

  let footerBottom = document.querySelector('[data-projects-more]');
  let footerProjects = document.querySelector('.footer__projects');
  footerBottom.addEventListener('click', (e) => {
      e.preventDefault();
      footerProjects.slideToggle(500).then(() => {
          if (footerProjects.classList.contains('DOM-slider-hidden')) {
              footerBottom.innerHTML = window.projectsMore;
          } else {
              footerBottom.innerHTML = window.projectsLess;
          }
      });
  });

  //MODAL CODE START
  (function () {
   
    function buildDocHtml(sections) {
      var html = '<div id="eu-fond" class="eu-fond">';
      html += '<div class="eu-fond__content">';
      for (var i = 0; i < sections.length; i++) {
        var s = sections[i];
        html += '<h3>' + s.title + '</h3>';
        html += s.text;
      }
      html += '</div>'; 
      html += '<div id="eu-close" data-eu-close></div>';
      html += '</div>'; 
      return html;
    }

    function openDoc(docId) {
      var docs = (window.i18n && window.i18n.docs) ? window.i18n.docs : {};
      var sections = docs[docId];
      if (!sections || !sections.length) return;

      var modal = basicLightbox.create(buildDocHtml(sections), {
        onShow: function () { document.body.classList.add('eu-fond__modal-visible'); },
        onClose: function () { document.body.classList.remove('eu-fond__modal-visible'); }
      });
      modal.show();

      var closeBtn = document.querySelector('#eu-fond [data-eu-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          modal.close();
          setTimeout(function () { window.scrollTo(0, document.body.scrollHeight); }, 500);
        }, { once: true });
      }
    }

    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-doc]') : null;
      if (!el) return;
      e.preventDefault();
      openDoc(el.getAttribute('data-doc'));
    });
  })();
  //MODAL CODE END

});

function initLinkOnChange(item) {
  let referencesMoreLink = item.querySelector('.reference-more--link');
  let target = referencesMoreLink.dataset.target;
  referencesMoreLink.addEventListener('click', (e) => {
    e.preventDefault();
    let targets = document.querySelectorAll(target);
    for (let j = 0; j < targets.length; j++) {
      let reference = targets[j];
      reference.style.display = 'block';
    }
    let links = document.querySelectorAll(`[data-target="${target}"]`);
    for (let k = 0; k < links.length; k++) {
      links[k].style.display = 'none';
    }
  });
}

function shuffle(array) {
  let currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

function rotate (event, el, coef = 20) {
    let x = event.clientX,
    w = window.innerWidth,
    midpoint = w / 2,
    pos = x - midpoint,
    val = (pos / midpoint) * coef;

    el.style.transform = `perspective(1000px) rotateY(${val}deg) rotateX(${val}deg)`;
}
